const LOAD_MORE_AMOUNT = {
  PARTIAL: 'PARTIAL',
  ALL: 'ALL',
};

export default LOAD_MORE_AMOUNT;
